import { action } from 'typesafe-actions';
export const FETCH_CAMPAIGN_REQUEST = '[Request] Fetch Campaign';
export const FETCH_CAMPAIGN_SUCCESS = '[Success] Fetch Campaign';
export const FETCH_CAMPAIGN_FAILURE = '[Failure] Fetch Campaign';
export const fetchCampaignRequest = () => action(FETCH_CAMPAIGN_REQUEST);
export const fetchCampaignSuccess = (banners, assets, name, tabName, mainTag, additionalTags) => action(FETCH_CAMPAIGN_SUCCESS, {
    name,
    tabName,
    mainTag,
    additionalTags,
    banners,
    assets
});
export const fetchCampaignFailure = (error) => action(FETCH_CAMPAIGN_FAILURE, { error });
//# sourceMappingURL=actions.js.map